import AdminPage from "./AdminPage.jsx";

export default function PublicPage() {
  return (
    <AdminPage
      readOnly
      allowSync={false}
      basePath="/public"
      requiredRoles={[]}
      pageTitle="Public Page"
      pageDescription="Read-only giveaway history and statistics."
    />
  );
}
